"use client"

import * as React from "react"
import { Check, ChevronsUpDown } from "lucide-react"
import { cn } from "../../../../utils/css"
import {
    Button,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@pushpress/pushpress-ui"

export function MultipleSelector({ title, options, values, onChange }: { title: string, options: { label: string, value: string }[], values: string[], onChange: (value: string[]) => void }) {
    const [open, setOpen] = React.useState(false)

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="tw-w-[480px] tw-flex tw-items-start tw-px-3 tw-py-2 tw-h-auto tw-justify-between"
                >
                    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-gap-y-1 tw-flex-1">
                        {values?.length
                            ? values.map((val, i) => (
                                <div
                                    key={i}
                                    className="tw-inline-flex tw-items-center tw-rounded-md tw-border tw-bg-muted tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-muted-foreground tw-mr-1 tw-mb-1"
                                >
                                    {options.find((option) => option.value === val)?.label}
                                </div>
                            ))
                            : `Select ${title}`}
                    </div>
                    <ChevronsUpDown className="tw-ml-2 tw-h-3 tw-w-3 tw-text-muted-foreground tw-self-center" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[480px] p-0">
                <Command>
                    <CommandInput placeholder={`Search ${title}`} />
                    <CommandEmpty>No {title} found.</CommandEmpty>
                    <CommandGroup>
                        <CommandList>
                            {options.map((option) => {
                                const isSelected = values.includes(option.value);
                                return (
                                    <CommandItem
                                        key={option.value}
                                        value={option.value}
                                        onSelect={() => {
                                            if (isSelected) {
                                                onChange(values.filter((v) => v !== option.value));
                                            } else {
                                                onChange([...values, option.value]);
                                            }
                                            // Do not close the dropdown here
                                        }}
                                    >
                                        <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
                                            <span>{option.label}</span>
                                            {isSelected ? (
                                                <Check className={cn("tw-h-4 tw-w-4 tw-text-primary")}/>
                                            ) : (
                                                <span className="tw-w-4 tw-h-4" />
                                            )}
                                        </div>
                                    </CommandItem>
                                );
                            })}
                        </CommandList>
                    </CommandGroup>
                </Command>
            </PopoverContent>
        </Popover>
    )
}
